import { Bot, Footprints, Handshake, Headset, Puzzle } from 'lucide-react';

import type { MedallionHue } from '@/components/bedrock';
import type { RivalCategory } from '@/features/comparisons';
import type { LucideIcon } from 'lucide-react';

/**
 * Per-category icon + hue.
 *
 * Lifted out of `VsIndex` because the DETAIL page now carries the same mark in
 * its hero: a reader who clicked a card marked "Product tours" should land on a
 * page that still says so, in the same colour, or the two surfaces read as two
 * unrelated pages about the same rival. One map rather than two is also the
 * only way that stays true — a second copy drifts the first time a category is
 * added, and the failure is silent (a page renders, it just wears the wrong
 * badge).
 */
export const CATEGORY_MARK: Record<RivalCategory, { icon: LucideIcon; hue: MedallionHue }> = {
  incumbent: { icon: Headset, hue: 'blue' },
  whiteGlove: { icon: Handshake, hue: 'violet' },
  smb: { icon: Bot, hue: 'cyan' },
  adjacent: { icon: Puzzle, hue: 'purple' },
  // A product tour walks someone through the product, so: footprints.
  dap: { icon: Footprints, hue: 'ok' },
};
